<unity-page-container
  [contentHeader]="$contentHeader()"
  [contentHeaderSecondary]="$contentHeaderSecondary()"
  [isLoading]="$resourceLoading()">
  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>
  <ng-container notifications />

  <ng-container actions>
    @let createAction = $createFormInstanceAction();
    @if (!!createAction) {
      <unity-action-shared [action]="createAction" />
    }
    <unity-workflow-selector-shared
      [transitions]="$availableTransitions()"
      [disabled]="$workflowActionsDisabled()"
      (workflowEvent)="onWorkflow($event)" />
    @if ($isDeletable()) {
      <unity-action-delete-shared
        *unityAuthorize="deleteEntitlement"
        [disabled]="$workflowActionsDisabled()"
        [buttonText]="`Delete ${resourceName}`"
        [confirmationTitle]="`Confirm Delete ${resourceName}?`"
        [confirmationMessage]="`Are you sure you want to delete this ${resourceName}?`"
        (deleteEvent)="onDelete()" />
    }
  </ng-container>

  @let formScheduleView = $resource();
  @let formGroup = $formGroup();
  @if (this.$isDraft()) {
    <unity-banner-alert-shared notifications icon="infoSolidIcon">
      This form is currently in a `Draft` state, visible only to AHFC users.
      <span *unityAuthorize="'FormResponse:Transition'"> Use the actions buttons to change its state. </span>
    </unity-banner-alert-shared>
  } @else if (this.$isDisabled()) {
    <unity-banner-alert-shared notifications icon="infoSolidIcon">
      This form is currently in a `Draft` state, visible only to AHFC users.
      <span *unityAuthorize="'FormResponse:Transition'"> Use the actions buttons to change its state. </span>
    </unity-banner-alert-shared>
  }
  <unity-panel-manage-shared
    [resource]="$resource()"
    [resourceName]="resourceName"
    [formGroup]="formGroup"
    [isEditable]="$isEntitledToEdit()"
    [submitLoading]="$updateLoading()"
    (saveEvent)="onSave()"
    (detailEditEvent)="toggleWorkflowActions($event)">
    <unity-form-layout>
      @if (formScheduleView) {
        <unity-textbox-readonly-control displayName="Agreement" [value]="formScheduleView.agreement.name" />
      }
      <unity-textbox-control displayName="Name" description="Specify the name of the form." [control]="formGroup.controls.name" />
      <unity-textarea-control
        displayName="Description"
        description="Specify the description of the form."
        [control]="formGroup.controls.description" />
      <unity-dropdown-form-schemas-control
        displayName="Form Schema"
        description="Select a form schema to use for this schedule."
        [control]="formGroup.controls.form_schema_id"
        [selectable]="$formSchemas()" />
      <unity-textbox-readonly-control
        displayName="Days Visible Before Open"
        [value]="formScheduleView?.days_visible_before_open?.toString() || ''" />
      <unity-textbox-readonly-control displayName="Start Date" [value]="formScheduleView?.start_date | dateTimezone" />
      @if (formScheduleView) {
        <unity-textbox-readonly-control displayName="Schedule Type" [value]="formScheduleView.type.name" />
        <unity-textbox-readonly-control displayName="Form Type" [value]="formScheduleView.form_type.name" />
      }
    </unity-form-layout>
  </unity-panel-manage-shared>
  @let fsId = $resourceId();
  @let aId = $agreementId();
  @if (!!fsId && !!aId) {
    <unity-grid-form-instance-shared *unityAuthorize="'FormSchedule:View'" [formScheduleId]="fsId" [agreementId]="aId" />
  }
</unity-page-container>
